<script>
import numeral from 'numeral'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import utilStyles from '@/assets/scss/modules/utilities.module.scss'
import { WarehouseService } from '@/services'

export default {
  data() {
    const { query } = this.$route

    return {
      items: [],
      pagination: {
        page: parseInt(query.page) || 1,
        total: 0,
        pageSize: 10
      },
      isLoading: false
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      const query = this.$route.query

      try {
        this.isLoading = true

        const {
          data: { result }
        } = await WarehouseService.sell.getAll({
          search: query.q,
          suggest_amount: query.type,
          page: query.page
        })

        this.items = result.results.map((item, index) => ({
          id: item.id,
          index: ((query.page || 1) - 1) * this.pagination.pageSize + index + 1,
          name: item.product ? item.product.name : null,
          image:
            item.product && item.product.image
              ? item.product.image.medium
              : null,
          target: item.suggest_amount,
          current: item.remaining_amount,
          unit:
            item.product && item.product.unit ? item.product.unit.name : null,
          productId: item.product ? item.product.id : null
        }))

        this.pagination = { ...this.pagination, total: result.count }
      } catch (err) {
        console.log(err)
        this.$notify.error(err.message)
      } finally {
        this.isLoading = false
      }
    },

    reset() {
      this.pagination.page = 1
    }
  },

  render() {
    const DetailButton = ({ props }) => {
      const handleClick = () => {
        this.$router.push({
          name: 'WarehouseDetail',
          params: { id: props.dataId, productId: props.productId }
        })
      }

      return (
        <el-button size="medium" onClick={handleClick}>
          See Detail <i class="el-icon-arrow-right"></i>
        </el-button>
      )
    }

    const Product = ({ props }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={props.image}
          alt="Product"
          style={{ flexShrink: '0', width: '2.5rem' }}
        />
        <div style={{ marginLeft: '0.5rem', flex: '1' }}>{props.label}</div>
      </div>
    )

    const toFormattedNumber = value => numeral(value).format('0,0')

    return (
      <el-card
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
        {...{ directives: [{ name: 'loading', value: this.isLoading }] }}
      >
        <el-table data={this.items}>
          <el-table-column
            label="No."
            prop="index"
            minWidth="60"
            align="right"
          ></el-table-column>
          <el-table-column
            label="ชื่อผลิตภัณฑ์"
            minWidth="250"
            scopedSlots={{
              default: ({ row }) => (
                <Product image={row.image} label={row.name} />
              )
            }}
          ></el-table-column>
          <el-table-column
            label="ผัง"
            minWidth="80"
            align="right"
            scopedSlots={{
              default: ({ row }) => (
                <span class={utilStyles.textSecondary}>
                  {toFormattedNumber(row.target)}
                </span>
              )
            }}
          ></el-table-column>
          <el-table-column
            label="คงเหลือ"
            minWidth="80"
            align="right"
            scopedSlots={{
              default: ({ row }) => (
                <span style={{ fontWeight: 'bold' }}>
                  {toFormattedNumber(row.current)}
                </span>
              )
            }}
          ></el-table-column>
          <el-table-column
            label="ทองขาด"
            minWidth="80"
            align="right"
            scopedSlots={{
              default: ({ row }) => {
                const value =
                  row.target > row.current ? row.target - row.current : 0
                return (
                  <span
                    class={value && utilStyles.colorSuccess}
                    style={value && { fontWeight: 'bold' }}
                  >
                    {toFormattedNumber(value)}
                  </span>
                )
              }
            }}
          ></el-table-column>
          <el-table-column
            label="ทองเกิน"
            minWidth="80"
            align="right"
            scopedSlots={{
              default: ({ row }) => {
                const value =
                  row.current > row.target ? row.current - row.target : 0
                return (
                  <span
                    class={value && utilStyles.colorDanger}
                    style={value && { fontWeight: 'bold' }}
                  >
                    {toFormattedNumber(value)}
                  </span>
                )
              }
            }}
          ></el-table-column>
          <el-table-column
            label="หน่วย"
            prop="unit"
            minWidth="100"
          ></el-table-column>
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => (
                <DetailButton dataId={row.id} productId={row.productId} />
              )
            }}
          ></el-table-column>
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={this.pagination.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'update:currentPage': value => {
                this.pagination.page = value
              },
              'current-change': async value => {
                await this.$router.replace({
                  query: { ...this.$route.query, page: value }
                })

                this.fetch()
              }
            }}
          />
        </div>
      </el-card>
    )
  }
}
</script>
